import { ApplicationStatus } from 'enums/ApplicationStatus';

export const MAX_LOAN_AMOUNT_RANGE = 500000;
export const MIN_LOAN_AMOUNT_RANGE = 15000;
export const MIN_LOAN_AMOUNT_FOR_SMALL_LOAN_PROGRAM = 2000;
export const MAX_LOAN_AMOUNT_FOR_SMALL_LOAN_PROGRAM = 14999;
export const LOAN_AMOUNT_SLIDER_STEP = 1000;
export const LOAN_TERM_CHANGES_ALLOWED_STATUSES = [
  ApplicationStatus.Purgatory,
  ApplicationStatus.Processing,
  ApplicationStatus.Compliance,
  ApplicationStatus.ReadyToSubmit,
];
export const LOAN_TERM_CHANGES_ALLOWED_STATUSES_FOR_SMALL_LOAN_PROGRAM = [ApplicationStatus.Processing];
